import {Modal, Spin} from "antd";
import {FC, useMemo} from "react";
import StaffForm from "./staff-form/StaffForm";
import {CreateStaffModalProps} from "./types";

const CreateStaffModal: FC<CreateStaffModalProps> = (props) => {
  const {staffController, staffRole} = props
  const {
    selectedStaff,
    staffForm,
    isCreateModalOpen,
    toggleCreateModal,
    createStaffHandler,
    updateStaff
  } = staffController

  const title = useMemo(() => {
    return selectedStaff ? `Редагування: ${selectedStaff.fullName}` : `Додати нового лікаря`
  }, [selectedStaff])

  const okButtonHandler = () => {
    staffForm.submit()
  }

  return <Modal width={1000} style={{top: 20}} title={title} open={isCreateModalOpen} onOk={okButtonHandler}
                onCancel={() => {
                  toggleCreateModal({selectedStaff: undefined, isModalOpen: false})
                }} cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={staffController.isLoading}>
      <StaffForm staffRole={staffRole} selectedStaff={selectedStaff} updateStaffHandler={updateStaff}
                 createStaffHandler={createStaffHandler}
                 staffForm={staffForm}/>
    </Spin>
  </Modal>
}

export default CreateStaffModal